import { createStyles, makeStyles } from '@material-ui/core';
import React from 'react';

import { TableGridApiContextProvider } from '../../../../../components/TableGrid/TableGridApiContext/TableGridApiContext';
import { api } from '../../../../../core/api';
import { useFilterState } from '../../../shared/FinancialDataContext/FinancialDataContext';
import { QueriesPanelTable } from '../QueriesPanelTable/QueriesPanelTable';

export const MyFilters: React.FC = () => {
  const classes = useStyles();
  const { saveFilterButtonState } = useFilterState();

  return (
    <TableGridApiContextProvider>
      <QueriesPanelTable
        className={classes.table}
        datasource={api.search.getMyFilters}
        refresh={saveFilterButtonState}
      />
    </TableGridApiContextProvider>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    table: {
      marginBottom: theme.spacing(10),
    },
  }),
);
